import Container from './CommentCountButton';
export default Container;

export const componentName = 'CommentCountButton';
